<template>
    <el-card body-style="padding: 20px 20px 0 20px;
                                    display: flex;
                                    flex-direction: column;
                                    box-sizing: border-box;
                                    height: 100%;
                                    justify-content: space-between;"
             class="list-item"
             :class="{'is-last-child': ((length + 1) % 3 === 2) && index === length - 1}"
             @mouseenter.native.stop="handleMouseEnter(item)"
             @mouseleave.native.stop="handleMouseLeave(item)">
        <header class="list-item--header">{{ item.Name }}</header>
        <span class="list-item-status">{{ QUESTION_STATUS[item.State] }}</span>
        <div class="font-size14" v-if="item.QuestionnaireStartTime && item.QuestionnaireEndTime">{{item.QuestionnaireStartTime + ' - ' +  item.QuestionnaireEndTime}}</div>
        <!-- 描述 -->
        <el-row type="flex"
                justify="space-between"
                align="middle"
                class="list-item--desc"
                v-show="!isShowActionsMap[item]">
            <span class="list-item-data">{{ item.Qty || 0 }}份数据</span>
            <span class="list-item-time">{{ item.ModifyTime | timeAgo }}</span>
        </el-row>
        <!-- 操作按钮 -->
        <el-row type="flex"
                justify="space-between"
                align="middle"
                v-show="isShowActionsMap[item]"
                class="list-item--desc list-item--actions">
            <span v-if="$store.state.isCheckEnd" @click.stop="routeEdit"><img src="@/assets/img/psq/sidebar-psq/file-editing.png" alt="edit-icon"
                                               class="base-img"/>编辑</span>
            <span @click.stop="handlePublish" v-if="item.State !== 3 && item.State !== 1"><img src="@/assets/img/psq/sidebar-psq/send-one.png" alt="send-icon"
                                                   class="base-img"/>{{item.State === 0 ? "发布" : "分享"}}</span>
            <span @click.stop="handleData"><img src="@/assets/img/psq/sidebar-psq/internal-data.png" alt="internal-data-icon" class="base-img"/>数据</span>
            <el-dropdown type="primary" trigger="click">
                <img src="@/assets/img/psq/sidebar-psq/more.png" alt="more-icon" width="30" height="10"/>
                <el-dropdown-menu slot="dropdown"
                                  @mouseleave.native.stop="handleMouseLeave(item)"
                                  @mouseenter.native.stop="handleMouseEnter(item)">
                    <el-dropdown-item @click.native.stop="handleDel">删除项目</el-dropdown-item>
                    <el-dropdown-item @click.native.stop="handleExport">导出项目</el-dropdown-item>
                    <el-dropdown-item @click.native.stop="handlePreview(item)">预览项目</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-row>
        <publish-questionnaire ref="publish"
                               @confirm="publishConfirm"/>
        <share ref="share"
               :is-show-back-question-list="false"
               :questionnaire-title="item.Name"
               :query="query"/>
    </el-card>
</template>

<script>
import { QUESTION_STATUS } from "@/utils/question-config"
import { timeAgo, getParent } from "@/utils"
import {
    recycleQuestionnaire,
    exportQuestion,
    publishQuestionnaire,
    addQuestion, getQuestionnaireDetail
} from "@/api/new-question-iteration/question-library"
import { downloadUrl } from "download.js"
import PublishQuestionnaire from "@/components/publishQuestionnaire";
import share from "@/views/manage/psq/msq/create-empty/cpns/share";
export default {
    name: "Card",
    components: {
        PublishQuestionnaire,
        share
    },
    data() {
        return {
            isShowActionsMap: {},
            QUESTION_STATUS
        }
    },
    props: {
        item: {},
        index: {
            type: Number
        },
        length: {
            type: Number,
            default: 0
        }
    },
    filters: {
        timeAgo
    },
    computed: {
        // 问卷收集中或者已结束
        isCollect () {
            return [2, 3].includes(parseInt(this.item.State))
        },
        query ({ item }) {
            return { Qid: item.Id, isViewResult: item.IsUserDispalyResult, from: this.$route.path, organId: this.$store.state.userInfo.GroupUserId }
        }
    },
    methods: {
        // 鼠标移入
        handleMouseEnter(item) {
            this.$set(this.isShowActionsMap, item, true)
        },
        // 鼠标移出
        handleMouseLeave(item) {
            this.$set(this.isShowActionsMap, item, false)
        },
        // 处理删除
        handleDel() {
            recycleQuestionnaire({
                Ids: this.item.Id,
                State: 2
            }).then(res => {
                const parent = getParent("AdminSidebarPsq", this.$parent)
                parent.getQuestionList(parent.searchVal)
                this.$message.success("删除成功")
            })
        },
        // 处理导出
        handleExport() {
            exportQuestion(this.item.Id).then(res => {
                downloadUrl(this.item.Name || "问卷", res)
            })
        },
        // 跳转编辑
        routeEdit() {
            const route = (qid, isPublish) => {
                this.$router.push({
                    name: "CreateEmpty",
                    query: {
                        from: this.$route.path,
                        Qid: qid,
                        isPublish: isPublish
                    }
                })
            }
            // 如果已经在收集中，或者已结束, 编辑的时候就复制一份
            if (this.isCollect) {
                this.$confirm(`您的问卷已收集 ${this.item.Qty || 0} 份数据，现在进行题目删改可能会影响已收集的数据。`, "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(async () => {
                    const res = await getQuestionnaireDetail(this.item.Id)
                    const { Name, Title, QuestionnaireDetaillist, Tag } = res
                    const id = await addQuestion({
                        Name,
                        Title,
                        Details: QuestionnaireDetaillist.map(list => Object.assign(list, { Id: undefined, QuestionnaireId: undefined })),
                        Tag
                    })
                    route(id, false)
                })
            } else {
                route(this.item.Id, parseInt(this.item.State) !== 0)
            }
        },
        // 处理发布
        handlePublish() {
            if (this.item.State === 0) {
                this.$refs.publish.open()
            } else {
                this.$refs.share.open()
            }
        },
        // 处理预览
        handlePreview(item) {
            this.$router.push(
                {
                    name: "ManageViewQuestion",
                    query: {
                        from: this.$route.path,
                        Qid: this.item.Id,
                        isPublish: parseInt(item.State) !== 0,
                    }
                }
            )
        },
        // 发布确认
        publishConfirm(val, close) {
            publishQuestionnaire({
                ...val,
                Id: this.item.Id
            }).then(res => {
                this.$message.success("发布成功")
                typeof close === "function" && close()
                const parent = getParent("AdminSidebarPsq", this.$parent)
                parent.getQuestionList(parent.searchVal)
                this.$nextTick(() => {
                    this.$refs.share.open()
                })
            }).catch(e => {
                typeof close === "function" && close(true)
            })
        },
        // 跳转到统计页面
        handleData() {
            if (this.isCollect) {
                this.$router.push({ name: "Stat", query: { Qid: this.item.Id, from: this.$route.path, title: this.item.Name, isViewResult: this.item.IsUserDispalyResult } })
            } else {
                this.$message.warning(`该问卷${QUESTION_STATUS[this.item.State]}，暂无统计数据`)
            }
        }
    }
}
</script>

<style scoped lang="less">
@import "../../index";

.list-item--header {
    font-size: 16px;
    word-break: break-all;
    font-weight: 600;
}

.list-item-status {
    color: @--color-warning;
    font-size: 14px;
}

.list-item-data {
    color: @--color-info;
    font-size: 14px;
}

.list-item-time {
    color: @--color-info;
    font-size: 14px;
}

.list-item--actions {
    background-color: @--color-primary;
    margin: 0 -20px;
    padding: 0 20px;

    > span {
        color: #fff;
    }
}

.list-item--desc {
    height: 60px;
}

.base-img {
    vertical-align: middle;
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
</style>
